<template>
  <ul :class="$style.root">
    <li v-for="locale in locales" :key="locale.code">
      <a
        :key="locale.code"
        :href="localeHref(locale.code)"
        :class="$style.link"
        :data-current=" currentLocale === locale.code ? '' : null "
      >
        {{ locale.code }}
      </a>
    </li>
  </ul>
</template>

<script setup>
const { locale: currentLocale, locales } = useI18n()
const switchLocalePath = useSwitchLocalePath()
const route = useRoute()

// `switchLocalePath` carries the incoming query forward verbatim, and Vue
// escapes `&` to `&amp;` when it serialises the href — so a request arriving
// with `?a=1&amp;b=2` got a link one `amp;` layer deeper, on every page. This
// component sits in layouts/default.vue, which error.vue also renders, so it
// kept the crawl loop alive even from the 410 page meant to contain it.
// Rebuild the query from the params the app actually reads.
const localeHref = (code) => {
  const path = switchLocalePath(code)

  // Falsy for a locale with no translation of this route — the template styles
  // a missing href as disabled, so pass it through untouched.
  if (!path) {
    return path
  }

  const [pathname] = path.split('?')
  const search = new URLSearchParams(filterRouteQuery(route?.query)).toString()

  return search ? `${pathname}?${search}` : pathname
}
</script>

<style module>
.root {
  composes: reset-list from global;

  display: flex;
  /* flex-wrap: wrap; */
  gap: .5ch;
}

.link {
  composes: reset-link from global;

  display: inline-block;
}

.link[data-current] {
  text-decoration-line: underline;
}

.link:hover {
  text-decoration-line: underline;
}

.link:not([href]) {
  opacity: var(--opacity--disabled);
  pointer-events: none;
}
</style>
